var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('avatars-group',_vm._g({attrs:{"items":_vm.users,"limit":_vm.limit,"size":_vm.size},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var active = ref.active;
var toggle = ref.toggle;
return [_c('user-avatar',{attrs:{"size":_vm.size,"thumbnail-on-click":_vm.thumbnailOnClick,"user":item,"bordered":""},nativeOn:{"click":function($event){return toggle.apply(null, arguments)}}})]}}])},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }